export const PLAYER_ELEMENT_ID = 'bitmovin-player';
export const BITMOVIN_LICENSE_KEY = 'a508280e-56ac-448b-a1e5-6012536f5e01';

export const DEFAULT_SOURCE_LOADING_ERROR_CODE = 1000;
